import { render, staticRenderFns } from "./ExpenseCategory.vue?vue&type=template&id=0a805d1d"
import script from "./ExpenseCategory.vue?vue&type=script&lang=js"
export * from "./ExpenseCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a805d1d')) {
      api.createRecord('0a805d1d', component.options)
    } else {
      api.reload('0a805d1d', component.options)
    }
    module.hot.accept("./ExpenseCategory.vue?vue&type=template&id=0a805d1d", function () {
      api.rerender('0a805d1d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/ExpenseCategory.vue"
export default component.exports